import { getChannelGlobals } from "../../data/channels";

const globals = getChannelGlobals(process.env.REACT_APP_FEATURE_SET);

export const updateGlobals = (channelCode) => {
    const newGlobals = getChannelGlobals(channelCode);
    Object.keys(newGlobals).forEach(key => {
        globals[key] = newGlobals[key];
    });
}

export default globals;
